export const getErrorId = (name: string) => {
    return `error-${name.replace(/\s/g, '')}`;
};
